module.exports = __webpack_public_path__ + "img/team1.a56ffc3e.png";